/**
 * Created by Ning Jiang on 3/20/2017.
 */
import {IBookOfShadowGameData, IBookOfShadowInitData, IBookOfShadowsServerData} from "./data/IBookOfShadowsServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {BookOfShadowsGameConfig} from "../BookOfShadowsGameConfig";
import {BookOfShadowsGameMode} from "../gameMode/BookOfShadowsGameMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";

export class BookOfShadowsServerDataParser extends SpinServerDataParser {

    public parseSelectedRowsBaseGame(rawData: IBookOfShadowsServerData): number {
        return rawData.playedRowsInBase;
    }

    public parseSelectedRowsFS(rawData: IBookOfShadowsServerData): number {
        if ((rawData as IBookOfShadowInitData).isRestoreState && rawData.nextMode === BookOfShadowsGameMode.FREESPIN_PICK) {
            BookOfShadowsGameConfig.instance.ACTIVE_ROWS = rawData.playedRowsInFS;
        }

        return rawData.playedRowsInFS;
    }

    public parseFsNumberOfSpins(rawData: IBookOfShadowsServerData): number[] {
        return rawData.fsNumberOfSpins;
    }

    public parseFsSpecialSymbol(rawData: IBookOfShadowsServerData): string {
        BookOfShadowsGameConfig.instance.FS_SPECIAL_SYMBOL = (rawData.mode !== BookOfShadowsGameMode.NORMAL || ((rawData as IBookOfShadowInitData).isRestoreState && rawData.nextMode !== BookOfShadowsGameMode.GAMBLE)) ? rawData.fsSpecialSymbol : "";

        return rawData.fsSpecialSymbol;
    }

    public parseFsSymbolPosition(rawData: IBookOfShadowGameData): number[] {
        return rawData.fsSymbolPosition;
    }

    public parseScatterWins(rawData: IBookOfShadowGameData): IBetLineWinData[] {
        return rawData.scatterWins;
    }

    public parseWasFeatureBuyInit(rawData: IBookOfShadowInitData): boolean {
        return rawData.wasFeatureBuy;
    }

    public parseFeatureBuyRows(rawData: IBookOfShadowsServerData): number {
        return rawData.featureBuyRows;
    }

    public parsePlayerChoseRedrawSymbol(rawData: IBookOfShadowsServerData): boolean {
        return rawData.playerChoseRedrawSymbol;
    }

    public parseScatterPositionsEnteringFreespin(rawData: IBookOfShadowInitData | IBookOfShadowGameData): number[] | undefined {
        return rawData.scatterPositions;
    }

    public parseBetWinsInit(rawData: IBookOfShadowInitData): IBetLineWinData[] | IBetWayWinData[] | undefined {
        switch (BookOfShadowsGameConfig.instance.BET_WIN_MODE) {
            case 1 /* BET_LINE */
            :
                return rawData.betLineWins;
            case 2 /* BET_WAY */
            :
                return rawData.betWayWins;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public parseNearWinReels(rawData: IBookOfShadowGameData): boolean[] {
        // #95, controlling from here, so that nearWinReels is false for each reel in the framework classes too.
        if (rawData.wasFeatureBuy && rawData.mode === BookOfShadowsGameMode.NORMAL) {
            return ArrayHelper.initArrayWithValues(BookOfShadowsGameConfig.instance.REELS_NUM, () => false);
        }

        return super.parseNearWinReels(rawData);
    }

    public parseAllowLockedReelsNextSpin(rawData: IBookOfShadowGameData): boolean {
        return rawData.allowLockedReelsNextSpin;
    }

    public parseLockedReelsSet(rawData: IBookOfShadowsServerData): string {
        return rawData.lockedReelsSet;
    }

    public parseLockedReelBet(rawData: IBookOfShadowInitData): number {
        return rawData.lockedReelBet;
    }

    public parseActualBetThisSpin(rawData: IBookOfShadowGameData): number {
        return rawData.actualBetThisSpin;
    }
}